__turbopack_context__.v({
  "infoBlockContainer": "InfoBlock-module-scss-module__fZVtgG__infoBlockContainer",
  "infoBlockContent": "InfoBlock-module-scss-module__fZVtgG__infoBlockContent",
});
